// ======================================================================
// File: src/modules/ipe/dashboard/crm/pages/CRMExecutiveDashboard.jsx
// Purpose:
// CRM Executive Dashboard
// ERP Style (No Material UI)
// ======================================================================

import React, { useState } from "react";

import CRMKpiCard from "../components/CRMKpiCard";

import SalesPipelineWidget
  from "../components/SalesPipelineWidget";

import RevenueTrendWidget
  from "../components/RevenueTrendWidget";

import RecentEnquiriesWidget
  from "../components/RecentEnquiriesWidget";

import PendingQuotationsWidget
  from "../components/PendingQuotationsWidget";

import RecentOrdersWidget
  from "../components/RecentOrdersWidget";

import TopCustomersWidget
  from "../components/TopCustomersWidget";

import CRMActivityTimeline
  from "../components/CRMActivityTimeline";

import CRMDetailDrawer
  from "../components/CRMDetailDrawer";

import CRMDashboardNavigator
  from "../components/CRMDashboardNavigator";

import {
  crmKpis,
  pipelineData,
  revenueTrend,
  recentEnquiries,
  pendingQuotations,
  recentOrders,
  topCustomers,
  crmActivities,
} from "../mock/crmDashboardMockData";

export default function CRMDashboard() {

    // ============================================================
  // DRAWER STATE
  // ============================================================

  const [drawerOpen, setDrawerOpen] =
    useState(false);

  const [drawerTitle, setDrawerTitle] =
    useState("");

  const [drawerType, setDrawerType] =
    useState("");

  const [drawerData, setDrawerData] =
    useState(null);
  // ============================================================
// OPEN DRAWER
// ============================================================

const openDrawer = (
  title,
  type,
  data
) => {
  setDrawerTitle(title);
  setDrawerType(type);
  setDrawerData(data);
  setDrawerOpen(true);
};
  
  const handleKpiClick = (kpi) => {
  openDrawer(
    kpi.title,
    "KPI",
    kpi
  );
};

  const handleEnquiryClick = (row) => {
  openDrawer(
    row.enquiry_no || "Enquiry Details",
    "Enquiry",
    row
  );
};

  const handleQuotationClick = (row) => {
    console.log("Quotation:", row);
  };

  const handleOrderClick = (row) => {
    console.log("Order:", row);
  };

  const handleCustomerClick = (row) => {
  openDrawer(
    row.customer || "Customer",
    "Customer",
    row
  );
};

  return (
    <div>
      

      {/* =====================================================
    EXECUTIVE HEADER
===================================================== */}

<div
  style={{
    background:
      "linear-gradient(135deg,#1e3a8a,#2563eb,#3b82f6)",
    borderRadius: "16px",
    padding: "20px 24px",
    marginBottom: "20px",
    color: "#fff",
    boxShadow: "0 8px 24px rgba(37,99,235,.25)",
  }}
>
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "20px",
    }}
  >
    {/* LEFT */}
    <div>
      <h2
        style={{
          margin: 0,
          fontSize: "28px",
          fontWeight: 700,
        }}
      >
        CRM Executive Dashboard
      </h2>

      <div
        style={{
          marginTop: "6px",
          opacity: 0.9,
          fontSize: "14px",
        }}
      >
        Enquiries • Quotations • Orders • Customer Performance
      </div>
    </div>

    {/* RIGHT KPI SUMMARY */}
    <div
      style={{
        display: "flex",
        gap: "30px",
        flexWrap: "wrap",
      }}
    >
      <div>
        <div
          style={{
            fontSize: "11px",
            opacity: 0.85,
            textTransform: "uppercase",
          }}
        >
          Revenue
        </div>

        <div
          style={{
            fontSize: "24px",
            fontWeight: 700,
          }}
        >
          ₹3.47 Cr
        </div>
      </div>

      <div>
        <div
          style={{
            fontSize: "11px",
            opacity: 0.85,
            textTransform: "uppercase",
          }}
        >
          Pipeline
        </div>

        <div
          style={{
            fontSize: "24px",
            fontWeight: 700,
          }}
        >
          ₹4.82 Cr
        </div>
      </div>

      <div>
        <div
          style={{
            fontSize: "11px",
            opacity: 0.85,
            textTransform: "uppercase",
          }}
        >
          Orders
        </div>

        <div
          style={{
            fontSize: "24px",
            fontWeight: 700,
          }}
        >
          62
        </div>
      </div>

      <div>
        <div
          style={{
            fontSize: "11px",
            opacity: 0.85,
            textTransform: "uppercase",
          }}
        >
          Conversion
        </div>

        <div
          style={{
            fontSize: "24px",
            fontWeight: 700,
          }}
        >
          67%
        </div>
      </div>
    </div>
  </div>
</div>

      {/* =====================================================
          KPI SECTION
      ===================================================== */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit, minmax(180px, 1fr))",
          gap: "16px",
          marginBottom: "24px",
        }}
      >
        {crmKpis.map((kpi) => (
  <CRMKpiCard
    key={kpi.id}
    title={kpi.title}
    value={kpi.value}
    trend={kpi.trend}
    trendType={kpi.trendType}
    icon={kpi.icon}
    color={kpi.color}
    sparkline={kpi.sparkline}
    onClick={() => handleKpiClick(kpi)}
  />
))}
      </div>

      {/* =====================================================
          PIPELINE + REVENUE
      ===================================================== */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit, minmax(500px, 1fr))",
          gap: "16px",
          marginBottom: "24px",
        }}
      >
        <SalesPipelineWidget
          data={pipelineData}
          onViewDetails={() =>
            console.log("Pipeline")
          }
          onStageClick={(stage) =>
            openDrawer(
              stage.stage,
              "Pipeline",
              stage
            )
          }
        />

        <RevenueTrendWidget
          revenueData={revenueTrend}
          onViewDetails={() =>
            console.log("Revenue")
          }
        />
      </div>

      {/* =====================================================
            ACTIVITY TIMELINE
        ===================================================== */}

        <div
          style={{
            marginBottom: "24px",
          }}
        >
          <CRMActivityTimeline
            activities={crmActivities}
          />
        </div>
      
      {/* =====================================================
          ENQUIRIES + QUOTATIONS
      ===================================================== */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit, minmax(500px, 1fr))",
          gap: "16px",
          marginBottom: "24px",
        }}
      >
        <RecentEnquiriesWidget
          enquiries={recentEnquiries}
          onViewAll={() =>
            console.log("All Enquiries")
          }
          onRowClick={handleEnquiryClick}
        />

        <PendingQuotationsWidget
          quotations={pendingQuotations}
          onViewAll={() =>
            console.log("All Quotations")
          }
          onRowClick={handleQuotationClick}
        />
      </div>

      {/* =====================================================
          ORDERS + CUSTOMERS
      ===================================================== */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit, minmax(500px, 1fr))",
          gap: "16px",
        }}
      >
        <RecentOrdersWidget
          orders={recentOrders}
          onViewAll={() =>
            console.log("All Orders")
          }
          onRowClick={handleOrderClick}
        />

        <TopCustomersWidget
          customers={topCustomers}
          onViewAll={() =>
            console.log("All Customers")
          }
          onCustomerClick={handleCustomerClick}
        />
      </div>
            {/* =====================================================
                  DETAIL DRAWER
              ===================================================== */}

              <div
                style={{
                  marginTop: "24px",
                }}
              >
                
              </div>
              
              <CRMDetailDrawer
                open={drawerOpen}
                title={drawerTitle}
                type={drawerType}
                data={drawerData}
                onClose={() =>
                  setDrawerOpen(false)
                }
              />    
    </div>
  );
}